import { render, staticRenderFns } from "./news4.vue?vue&type=template&id=2fbde9a5&scoped=true"
import script from "./news4.vue?vue&type=script&lang=js"
export * from "./news4.vue?vue&type=script&lang=js"
import style0 from "./news4.vue?vue&type=style&index=0&id=2fbde9a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbde9a5",
  null
  
)

export default component.exports